const v = "type-page:";
function E(n, e) {
  const r = /* @__PURE__ */ new Map();
  for (const a of n) {
    const s = a.parentFolderId ?? null, t = r.get(s) ?? [];
    t.push(a), r.set(s, t);
  }
  const d = [], l = [e], o = /* @__PURE__ */ new Set();
  for (; l.length > 0; ) {
    const a = l.shift();
    if (!o.has(a)) {
      o.add(a), d.push(a);
      for (const s of r.get(a) ?? []) l.push(s.folderId);
    }
  }
  return d;
}
function _(n, e, r) {
  const d = new Map(n.map((a) => [a.folderId, a]));
  let l = e;
  const o = /* @__PURE__ */ new Set();
  for (; l; ) {
    if (l === r) return !0;
    if (o.has(l)) break;
    o.add(l), l = d.get(l)?.parentFolderId ?? null;
  }
  return !1;
}
const P = (n, e) => n.name.localeCompare(e.name, void 0, {
  numeric: !0,
  sensitivity: "base"
}) || n.folderId.localeCompare(e.folderId);
function j(n) {
  const e = new Map(n.map((a) => [a.folderId, a])), r = /* @__PURE__ */ new Map();
  for (const a of e.values()) {
    const s = a.parentFolderId ?? null, t = s !== a.folderId && e.has(s ?? "") ? s : null, i = r.get(t) ?? [];
    i.push(a), r.set(t, i);
  }
  for (const a of r.values())
    a.sort(P);
  const d = [{ folderId: null, name: "Root", depth: 0 }], l = /* @__PURE__ */ new Set(), o = (a, s) => {
    if (!l.has(a.folderId)) {
      l.add(a.folderId), d.push({ folderId: a.folderId, name: a.name, depth: s });
      for (const t of r.get(a.folderId) ?? [])
        o(t, s + 1);
    }
  };
  for (const a of r.get(null) ?? [])
    o(a, 0);
  for (const a of [...e.values()].sort(P))
    o(a, 0);
  return d;
}
function x(n, e) {
  return n === void 0 ? e ?? null : n;
}
function u(n) {
  return n ? n.replace(/\\/g, "/").split("/").map((e) => e.trim()).filter(Boolean).join("/") : "";
}
function y(n) {
  const e = u(n);
  if (!e || !e.includes("/"))
    return null;
  const r = e.split("/");
  return r.pop(), r.join("/") || null;
}
function I(n) {
  const e = u(n);
  if (!e) return "";
  const r = e.split("/");
  return r[r.length - 1] || e;
}
function g(n, e) {
  const r = u(n), d = u(e);
  return r ? d ? `${r}/${d}` : r : d;
}
function U(n, e) {
  return g(y(n), e);
}
function w(n) {
  return u(n.title || n.documentId);
}
const h = "Shared document";
function M(n, e) {
  const r = u(n.title), d = r && r !== n.documentId ? I(r) : h;
  if (!n.parentFolderId)
    return r && r !== n.documentId ? r : d;
  const l = new Map(e.map((t) => [t.folderId, t])), o = [], a = /* @__PURE__ */ new Set();
  let s = l.get(n.parentFolderId);
  if (!s && r.includes("/")) return r;
  for (; s && !a.has(s.folderId); )
    a.add(s.folderId), s.name.trim() && o.unshift(s.name.trim()), s = s.parentFolderId ? l.get(s.parentFolderId) : void 0;
  return o.push(d), u(o.join("/")) || h;
}
function z(n, e) {
  const r = u(n);
  return !r || r === e ? h : I(r) || h;
}
function K(n, e, r) {
  const d = z(e, r);
  if (d !== h) return d;
  const l = u(n);
  return !l || l === r ? h : I(l) || h;
}
function W(n, e, r) {
  const d = u(r), l = d && d !== n.documentId ? d : h, o = u(n.title);
  return !o || o === n.documentId || !!(n.parentFolderId && !e.some((s) => s.folderId === n.parentFolderId)) && !o.includes("/") && l !== h ? l : M(n, e);
}
const A = {
  folder: 0,
  type: 1,
  document: 2,
  item: 3
}, C = (n) => A[n.type], T = (n, e) => n.placement.sortOrder - e.placement.sortOrder || n.name.localeCompare(e.name, void 0, { numeric: !0, sensitivity: "base" }) || n.typeId.localeCompare(e.typeId);
function O(n, e) {
  const r = C(n) - C(e);
  if (r !== 0) return r;
  if (n.type === "type" && e.type === "type") return T(n, e);
  if (n.type === "item" && e.type === "item") {
    const d = (n.sortOrder ?? 0) - (e.sortOrder ?? 0);
    if (d !== 0) return d;
  }
  return n.name.localeCompare(e.name, void 0, {
    numeric: !0,
    sensitivity: "base"
  });
}
function F(n) {
  n.sort(O);
  for (const e of n)
    (e.type === "folder" || e.type === "document" && e.children) && F(e.children);
  return n;
}
function k(n, e) {
  const r = /* @__PURE__ */ new Map();
  for (const o of n) {
    if (r.has(o.typeId)) continue;
    const a = e.typeName(o.typeId);
    if (!a) continue;
    const s = e.typeError?.(o.typeId);
    r.set(o.typeId, {
      id: `type:${o.typeId}`,
      type: "type",
      typeId: o.typeId,
      path: "",
      name: a,
      count: e.itemsOfType(o.typeId).length,
      placement: o,
      children: [],
      ...s ? { error: s } : {}
    });
  }
  const d = (o) => {
    const a = /* @__PURE__ */ new Set([o]);
    let s = e.typeExtends?.(o) ?? null;
    for (; s && !a.has(s); ) {
      if (r.has(s)) return s;
      a.add(s), s = e.typeExtends?.(s) ?? null;
    }
    return null;
  }, l = /* @__PURE__ */ new Map();
  for (const o of r.keys()) l.set(o, d(o));
  for (const o of r.keys()) {
    const a = /* @__PURE__ */ new Set([o]);
    let s = l.get(o) ?? null;
    for (; s; ) {
      if (a.has(s)) {
        l.set(o, null);
        break;
      }
      a.add(s), s = l.get(s) ?? null;
    }
  }
  return { nodes: r, parentType: l };
}
function N(n, e, r) {
  if (!r || r.placements.length === 0) return;
  const { resolver: d } = r, { nodes: l, parentType: o } = k(r.placements, d), a = /* @__PURE__ */ new Map();
  for (const t of l.values()) {
    const i = o.get(t.typeId);
    if (i) {
      const f = a.get(i) ?? [];
      f.push(t), a.set(i, f);
      continue;
    }
    const c = t.placement.parentFolderId, p = c ? e(c) : void 0;
    p ? p.children.push(t) : n.push(t);
  }
  const s = (t, i) => {
    t.path = g(i, t.name);
    const c = (a.get(t.typeId) ?? []).sort(T);
    for (const f of c) s(f, t.path);
    const p = d.itemsOfType(t.typeId).map((f) => {
      const m = f.title || f.itemId;
      return {
        id: `item:${f.itemId}`,
        type: "item",
        itemId: f.itemId,
        typeId: t.typeId,
        path: g(t.path, m),
        name: m,
        ...t.error ? { typeError: t.error } : {}
      };
    });
    t.children = [...c, ...p];
  };
  for (const t of l.values()) {
    if (o.get(t.typeId)) continue;
    const i = t.placement.parentFolderId, c = i ? e(i) : void 0;
    s(t, c ? c.path : "");
  }
}
function B(n, e, r) {
  const d = /* @__PURE__ */ new Map(), l = [], o = (s, t) => {
    if (!t) {
      l.push(s);
      return;
    }
    a(t).children.push(s);
  }, a = (s) => {
    const t = u(s), i = d.get(t);
    if (i)
      return i;
    const c = {
      id: `folder:${t}`,
      type: "folder",
      path: t,
      name: I(t),
      children: []
    };
    return d.set(t, c), o(c, y(t)), c;
  };
  for (const s of e) {
    const t = u(s);
    t && a(t);
  }
  for (const s of n) {
    const t = w(s);
    if (!t) continue;
    const i = y(t);
    i && a(i);
    const c = {
      id: `document:${s.documentId}`,
      type: "document",
      path: t,
      name: I(t),
      document: s
    };
    o(c, i);
  }
  return N(l, () => {
  }, r), F(l);
}
function $(n, e, r) {
  const d = new Map(e.map((t) => [t.folderId, t])), l = /* @__PURE__ */ new Map(), o = [], a = /* @__PURE__ */ new Map(), s = (t) => {
    const i = a.get(t);
    if (i !== void 0) return i;
    const c = d.get(t);
    if (!c) return "";
    const p = /* @__PURE__ */ new Set(), f = [];
    let m = c;
    for (; m && !p.has(m.folderId); )
      p.add(m.folderId), f.unshift(m.name), m = m.parentFolderId ? d.get(m.parentFolderId) : void 0;
    const b = u(f.join("/"));
    return a.set(t, b), b;
  };
  for (const t of e)
    l.set(t.folderId, {
      id: `folder:${t.folderId}`,
      type: "folder",
      path: s(t.folderId),
      name: t.name,
      children: [],
      folderId: t.folderId,
      folder: t
    });
  for (const t of e) {
    const i = l.get(t.folderId), c = t.parentFolderId ? l.get(t.parentFolderId) : void 0;
    c ? c.children.push(i) : o.push(i);
  }
  for (const t of n) {
    const i = t.parentFolderId ?? null, c = i ? l.get(i) : void 0, p = I(t.title) || t.title || t.documentId, f = c ? c.path : "", m = {
      id: `document:${t.documentId}`,
      type: "document",
      path: g(f, p),
      name: p,
      document: t
    };
    c ? c.children.push(m) : o.push(m);
  }
  return N(o, (t) => l.get(t), r), F(o);
}
function q(n, e, r) {
  const d = u(e), l = u(r);
  if (!d || !l) return [];
  const o = y(d), a = g(o, l);
  if (!a || a === d) return [];
  const s = `${d}/`, t = [];
  for (const i of n) {
    const c = w(i);
    c.startsWith(s) && t.push({
      documentId: i.documentId,
      newTitle: a + c.slice(d.length)
    });
  }
  return t;
}
function Q(n, e, r) {
  return e.length === 0 && n.some(
    (l) => !l.parentFolderId && y(w(l)) !== null
  ) ? B(n, [], r) : $(n, e, r);
}
function G(n) {
  const e = (r) => {
    if (r.type !== "folder") return r;
    const d = r.children.map(e).filter((l) => l !== null);
    return d.length === 0 ? null : { ...r, children: d };
  };
  return n.map(e).filter((r) => r !== null);
}
function H(n, e) {
  const r = e.trim().toLocaleLowerCase();
  if (!r)
    return n;
  const d = (o) => o.path.toLocaleLowerCase().includes(r) || o.name.toLocaleLowerCase().includes(r), l = (o) => {
    if ((o.type === "item" || o.type === "document") && !o.children?.length)
      return d(o) ? o : null;
    if (d(o))
      return o;
    if (o.type === "type") {
      const s = o.children.map(l).filter((t) => t !== null && (t.type === "type" || t.type === "item"));
      return s.length === 0 ? null : { ...o, children: s };
    }
    const a = (o.children ?? []).map(l).filter((s) => s !== null);
    return a.length === 0 ? null : {
      ...o,
      children: a
    };
  };
  return n.map(l).filter((o) => o !== null);
}
function R(n, e) {
  const r = I(n) || n;
  return e === "markdown" && /.\.md$/i.test(r) ? r.slice(0, -3) : r;
}
const D = (n) => n.startsWith(v);
function S(n) {
  return n.filter((e) => e.trashedAt == null && !D(e.documentId)).map((e) => ({
    folderId: e.documentId,
    parentFolderId: e.parentFolderId ?? null,
    ...e.parentKind === "item" ? { parentKind: "item" } : {},
    name: R(e.title, e.documentType) || h,
    sortOrder: 0,
    createdBy: e.createdBy,
    createdAt: e.createdAt,
    // Not `updatedAt`: a body edit is not a change to the page as a parent.
    updatedAt: e.createdAt,
    ...e.decryptFailed ? { decryptFailed: !0 } : {}
  }));
}
function L(n, e) {
  return E(S(n), e);
}
function V(n, e, r) {
  const d = n.map((t) => ({ ...t, trashedAt: null })), l = new Set(L(d, r)), o = new Set(S(d).map((t) => t.folderId)), a = [...l], s = [];
  for (const t of d) {
    if (!D(t.documentId) || !t.parentFolderId || !l.has(t.parentFolderId)) continue;
    const i = t.documentId.slice(v.length), c = e.find((p) => p.typeId === i)?.parentFolderId ?? null;
    if (c && l.has(c))
      a.push(t.documentId);
    else {
      const p = c && o.has(c) ? c : null;
      s.push({ documentId: t.documentId, parentId: p });
    }
  }
  return { removedIds: a, childCount: a.length - 1, relocate: s };
}
export {
  W as A,
  K as B,
  U as C,
  F as D,
  v as T,
  h as U,
  I as a,
  k as b,
  E as c,
  Q as d,
  T as e,
  j as f,
  M as g,
  O as h,
  D as i,
  g as j,
  z as k,
  y as l,
  S as m,
  u as n,
  _ as o,
  R as p,
  q,
  V as r,
  G as s,
  w as t,
  x as u,
  L as v,
  N as w,
  B as x,
  $ as y,
  H as z
};
//# sourceMappingURL=collabTree-CAWl6jZl.js.map
